<template>
  <Card>
    <template slot="title">
      <Breadcrumb>
        <BreadcrumbItem to="/order/delivery">订单妥投信息</BreadcrumbItem>
        <BreadcrumbItem>详情信息</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <router-link to="/order/delivery" slot="extra">返回</router-link>
    <table>
      <tr>
        <th>订单号</th>
        <td>{{detail.orderId}}</td>
        <th>门面编号</th>
        <td>{{detail.retCode}}</td>
        <th>App订单号</th>
        <td>{{detail.outOrderId}}</td>
      </tr>
      <tr>
        <th>物流公司</th>
        <td>{{detail.logisticsName}}</td>
        <th>面单号</th>
        <td colspan="3">{{detail.logisticsCode}}</td>
      </tr>
      <tr>
        <th>收货地址信息</th>
        <td colspan="5" style="width: 85%; padding-bottom: 10px;">
          <table>
            <tr>
              <th>省份</th>
              <td>
                {{detail.addressInfo.provinceName}}
              </td>
              <th>城市</th>
              <td>
                {{detail.addressInfo.cityName}}
              </td>
            </tr>
            <tr>
              <th>县/区</th>
              <td>{{detail.addressInfo.countyName}}</td>
              <th>街道</th>
              <td>{{detail.addressInfo.streetName}}</td>
            </tr>
            <tr>
              <th>收件人</th>
              <td>{{detail.addressInfo.receivePerson}}</td>
              <th>收件手机号</th>
              <td>{{detail.addressInfo.receiveMobile}}</td>
            </tr>
            <tr>
              <th>详细地址</th>
              <td colspan="3">{{detail.addressInfo.addr}}</td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <th>收货地址[经度/纬度]</th>
        <td>{{"["+detail.orderLongi+"]["+detail.orderLati+"]"}}</td>
        <th>收件人</th>
        <td>{{detail.receivePerson}}</td>
        <th>收件人手机</th>
        <td>{{detail.receiveMobile}}</td>
      </tr>
      <tr>
        <th>妥投时间</th>
        <td>{{detail.deliveryTime}}</td>
        <th>妥投状态</th>
        <td>{{detail.deliveryStatus}}</td>
        <th>妥投操作码</th>
        <td>{{detail.deliveryCode}}</td>
      </tr>
      <tr>
        <th>妥投距离</th>
        <td>{{detail.deliveryDistance}}米</td>
        <th>妥投[经/纬度]</th>
        <td colspan="3">{{"["+detail.deliveryPunchLng + "] [" + detail.deliveryPunchLat+"]" }}</td>
      </tr>
      <tr>
        <th>妥投地址</th>
        <td colspan="5">{{detail.deliveryPunchAddress}}</td>
      </tr>
      <tr>
        <th>妥投备注</th>
        <td colspan="5">{{detail.deliveryRemark}}</td>
      </tr>
      <tr>
        <th>创建时间</th>
        <td>{{detail.createtime}}</td>
        <th>更新时间</th>
        <td colspan="3">{{detail.updatetime}}</td>
      </tr>
      <tr>
        <th>备注</th>
        <td colspan="5">{{detail.remark}}</td>
      </tr>
      <tr>
        <th>地图</th>
        <td colspan="5">
<!--          <template>-->
<!--            <baidu-map class="map" :center=addrPoint :zoom="16">-->
<!--              <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>-->
<!--              <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>-->
<!--              <bm-marker :position=addrPoint :dragging="true" @click="addrWindowOpen">-->
<!--                <bm-info-window :show="addrShow" @close="addrWindowClose" @open="addrWindowOpen"-->
<!--                                style="font-size:13px">-->
<!--                  收货地址：{{detail.addressInfo.provinceName + detail.addressInfo.cityName + detail.addressInfo.countyName +-->
<!--                  detail.addressInfo.streetName}}<br>-->
<!--                  {{detail.addressInfo.addr}}-->
<!--                </bm-info-window>-->
<!--              </bm-marker>-->
<!--              <bm-marker :position=deliveryPoint :dragging="true" @click="infoWindowOpen">-->
<!--                <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen" style="font-size:13px">-->
<!--                  妥投地址：{{detail.addressInfo.provinceName + detail.addressInfo.cityName + detail.addressInfo.countyName +-->
<!--                  detail.addressInfo.streetName}}<br>-->
<!--                  {{detail.deliveryPunchAddress}}-->
<!--                </bm-info-window>-->
<!--              </bm-marker>-->
<!--            </baidu-map>-->
<!--          </template>-->
          <template>
            <div id="container" style="width:100%; height:600px"></div>
          </template>
        </td>
      </tr>
    </table>
  </Card>
</template>
<script>
  import Vue from 'vue'
  // import BaiduMap from 'vue-baidu-map'
  //
  // Vue.use(BaiduMap, {
  //   ak: 'gfBO5n2X8aaRvqnWtIPKrM9BwMhmPlvL'
  // });

  export default {
    data() {
      return {
        name: '详情',
        addrPoint: {lng: "", lat: ""},
        deliveryPoint: {lng: "", lat: ""},
        show: true,
        addrShow: false,
        detail: {
          id: "",
          orderId: "",
          sfApiDetailId: "",
          receivePerson: "",
          receiveMobile: "",
          addressInfo: {
            addr: "",
            cityId: "",
            cityName: "",
            countyId: "",
            countyName: "",
            platformCode: "",
            provinceId: "",
            provinceName: "",
            receiveMobile: "",
            receivePerson: "",
            retCode: "",
            streetId: "",
            streetName: "",
          },
          orderLongi: "",
          orderLati: "",
          logisticsCode: "",
          status: "",
          deliveryStatus: "",
          deliveryCode: "",
          deliveryTime: "",
          deliveryDistance: "",
          deliveryPunchAddress: "",
          deliveryPunchLng: "",
          deliveryPunchLat: "",
          createtime: "",
          updatetime: "",
        },

        AMapUI: null,
        AMap: null,
        map: null,
      }
    },
    created() {
      let query = this.$route.query;
      this.getDetail();

      let AMapUI = (this.AMapUI = window.AMapUI);
      let AMap = (this.AMap = window.AMap);
      this.AMapUI = AMapUI;
      this.AMap = AMap;
      this.AMapUI.loadUI(["misc/PositionPicker"], PositionPicker => {
        let mapConfig = {
          zoom: 20,
          center: [query.deliveryPunchLng, query.deliveryPunchLat],
          resizeEnable: true,
        };
        let map = new this.AMap.Map("container", mapConfig);
        this.map = map;
        this.AMap.plugin(["AMap.ToolBar", "AMap.Scale", "AMap.MapType"], function () {
          map.addControl(new AMap.ToolBar({}));
          map.addControl(new AMap.Scale({}));
          map.addControl(new AMap.MapType({}));
        });

        let lngLats = [
          [query.deliveryPunchLng, query.deliveryPunchLat],
          [query.orderLongi, query.orderLati]
        ];

        let infos = [
          {
            title: "妥投地址",
            content: query.deliveryAddr,
            anchor: "bottom-right",
          }, {
            title: "收货地址",
            content: query.address,
            anchor: "bottom-left"
          }
        ];

        let infoWindow = new this.AMap.InfoWindow({offset: new this.AMap.Pixel(0, -30)});
        for (let i = 0, marker; i < lngLats.length; i++) {
          let marker = new AMap.Marker({
            position: lngLats[i],
            map: map
          });

          let info = [];
          info.push("<p class='input-item'>" + infos[i].title + "</p>");
          info.push("<p class='input-item'>地址 :" + infos[i].content + "</p></div></div>");
          infoWindow.setContent(info.join(""))
          infoWindow.setAnchor(infos[i].anchor)
          infoWindow.open(map, marker.getPosition());

          //鼠标点击marker弹出自定义的信息窗体
          this.AMap.event.addListener(marker, 'click', function () {
            infoWindow.setContent(info.join(""))
            infoWindow.setAnchor(infos[i].anchor)
            infoWindow.open(map, marker.getPosition());
          });
        }
        map.add(marker);
      });
    },
    mounted() {
    },
    methods: {
      getDetail() {
        let data = this.$route.query;
        let id = data.id;
        this.$api.getOrderDeliveryDetail({id: id}).then((res) => {
          if (res.code == '200') {
            this.detail = res.data;
            this.detail.addressInfo = JSON.parse(res.data.addressInfo);

            let name = "";
            if (res.data.status == 0) name = "待处理";
            else if (res.data.status == 1) name = "处理中";
            else if (res.data.status == 200) name = "处理完成";
            else name = res.data.status;
            this.detail.status = name;

            let desc = "";
            if (res.data.deliveryStatus == 0) desc = "待处理";
            else if (res.data.deliveryStatus == -255) desc = "妥投异常";
            else if (res.data.deliveryStatus == 200) desc = "妥投成功";
            else desc = res.data.status;

            this.detail.deliveryStatus = desc;
            this.deliveryPoint.lng = res.data.deliveryPunchLng;
            this.deliveryPoint.lat = res.data.deliveryPunchLat;
            this.addrPoint.lng = res.data.orderLongi;
            this.addrPoint.lat = res.data.orderLati;
          }
        });
      },
      infoWindowClose() {
        this.show = false
      },
      infoWindowOpen() {
        this.show = true
        this.addrShow = false;
      },
      addrWindowClose() {
        this.addrShow = false;
      },
      addrWindowOpen() {
        this.addrShow = true;
        this.show = false;
      }
    }
  }
</script>
<style scoped>
  table {
    width: 100%;
    margin-top: 10px;
    border-collapse: collapse;
  }

  th, td {
    padding: 0 10px;
    text-align: center;
    border: 1px solid #dcdee2;
    line-height: 30px;
    color: #515a6e;
    font-size: 12px;
  }

  th {
    background: #f8f8f9;
  }

  .map {
    width: 99%;
    height: 398px;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/deliveryDetail.vue